import React from 'react';
import './Global404Page.css';

const Global404Page = () => (
  <main className="global-404" role="main">
    <section className="global-404__card" aria-labelledby="global-404-title">
      <div className="global-404__art" aria-hidden="true">
        <svg viewBox="0 0 520 330" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="260" cy="162" r="138" fill="#EFF6FF" />
          <circle cx="107" cy="72" r="14" fill="#BFDBFE" />
          <circle cx="424" cy="242" r="10" fill="#BFDBFE" />
          <path d="M130 253C177 226 335 226 390 253" stroke="#93C5FD" strokeWidth="7" strokeLinecap="round" />
          <path d="M177 244V135C177 116 193 100 213 100H308C328 100 344 116 344 135V244" fill="white" stroke="#2563EB" strokeWidth="7" strokeLinejoin="round" />
          <path d="M218 100V77C218 58 234 43 253 43H268C287 43 303 58 303 77V100" stroke="#2563EB" strokeWidth="7" strokeLinecap="round" />
          <path d="M220 145H301" stroke="#DBEAFE" strokeWidth="8" strokeLinecap="round" />
          <path d="M220 170H277" stroke="#DBEAFE" strokeWidth="8" strokeLinecap="round" />
          <rect x="223" y="196" width="75" height="48" rx="12" fill="#2563EB" />
          <path d="M247 220H275" stroke="white" strokeWidth="6" strokeLinecap="round" />
          <path d="M151 114L134 97M369 114L386 97M138 177H113M382 177H407" stroke="#60A5FA" strokeWidth="7" strokeLinecap="round" />
        </svg>
      </div>
      <p className="global-404__eyebrow">My Digital Schools</p>
      <h1 id="global-404-title">We’ll be right back.</h1>
      <p className="global-404__copy">This area is temporarily unavailable while we make a few improvements.</p>
      <div className="global-404__code">404</div>
    </section>
  </main>
);

export default Global404Page;
